import shopFront from '../../images/shopFront.jpg';
import { NavLink } from 'react-router-dom';
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaGlobe,
    FaClock,
} from "react-icons/fa";
import "./contact.scss";

const ContactPage = () => {
    return (
        <div className="contact-page">

            {/* MAIN 2-COLUMN LAYOUT */}
            <div className="contact-layout fade-up">

                {/* LEFT SIDE — MAP ONLY */}
                <div className="left-content">

                    <div className="map-container fade-up delay-1">
                        <iframe 
                            width="100%" 
                            height="600"  
                            scrolling="no" 
                            title="Oldkent Shisha Lounge"
                            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Shisha%20Lounge,%20350%20Old%20Kent%20Road,%20London,%20SE1%205AA+(Shisha%20Lounge)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                                <a href="https://www.mapsdirections.info/de/evolkerung-auf-einer-karte-berechnen/">Bevölkerung visualisieren Karte</a>
                        </iframe>

                    </div>
                </div>

                {/* RIGHT SIDE — BANNER IMAGE */}
                <div className="right-banner fade-up delay-2">
                    <img src={shopFront} alt="Contact Banner" />
                </div>
            </div>

            {/* CONTACT INFO CARDS */}
            <div className="info-cards-wrapper">
                <div className="contact-info-cards">

                    <div className="info-card fade-up delay-0">
                        <div className="info-card-icon">
                            <FaMapMarkerAlt />
                        </div>
                        <h3>Oldkent Shisha</h3>
                        <p>350 Old Kent Rd</p>
                        <p>London SE1 5AA</p>
                        <a
                            href="https://www.google.com/maps/place/350+Old+Kent+Rd"
                            target="_blank"
                            rel="noreferrer"
                        >
                            View Map
                        </a>
                    </div>

                    <div className="info-card fade-up delay-1">
                        <div className="info-card-icon">
                            <FaPhoneAlt />
                        </div>
                        <h3>Call Us</h3>
                        <NavLink to="tel:02077014646">020 7701 4646</NavLink>
                    </div>

                    <div className="info-card fade-up delay-2">
                        <div className="info-card-icon">
                            <FaEnvelope />
                        </div>
                        <h3>Email</h3>
                        <NavLink to="mailto:hello@oldkent-shisha.co.uk">hello@oldkent-shisha.co.uk</NavLink>
                    </div>

                    <div className="info-card fade-up delay-3">
                        <div className="info-card-icon">
                            <FaGlobe />
                        </div>
                        <h3>Website</h3>
                        <p>www.oldkent-shisha.co.uk</p>
                    </div>

                    <div className="info-card fade-up delay-4">
                        <div className="info-card-icon">
                            <FaClock />
                        </div>
                        <h3>Opening Hours</h3>
                        <p>Mon – Sun</p>
                        <p>16:00 – 23:00</p>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default ContactPage;
